export const PRIZE_TYPE_SUFFIX = {
  delayed: "delayed_lottery",
  instant: "instant_lottery",
};
